//Sarada : 10-10-2022
import { Collapse } from 'antd';
import React from "react"


const { Panel } = Collapse;
const regex = /(<([^>]+)>)/ig;
const secondRegEx = /((&nbsp;))*/gmi;




const Faq = (props) => {
    return (
        <div className="faq-cont">
       <div className="faq-title">{props.title}</div>
            <Collapse defaultActiveKey={['1']} accordion>

                {props.getfaqsList && props.getfaqsList.map((item,key) => (
                 <Panel header={item.Question} key={key+1}>
                 <p>{item.Answer.replace(regex, '').replace(secondRegEx, '')}</p>
                 </Panel>

              ))}

{/* 
                <Panel header="What is the per day car rental price in Mumbai?" key="2">
                <p>You can rent a car in Mumbai either by booking online on Skycars’s website or by calling us on 12345 12345.</p>
                </Panel>
                <Panel header="How much does it cost to rent a car for a week in Mumbai?" key="3">
                <p>You can rent a car in Mumbai either by booking online on Skycars’s website or by calling us on 12345 12345.</p>
                </Panel>
                <Panel header="How much does it cost to rent a car for a month in Mumbai?" key="4">
                <p>You can rent a car in Mumbai either by booking online on Skycars’s website or by calling us on 12345 12345.</p>
                </Panel>
                <Panel header="Does Skycars.in Provide CNG car rental service in Mumbai?" key="5">
                <p>You can rent a car in Mumbai either by booking online on Skycars’s website or by calling us on 12345 12345.</p>
                </Panel> */}
            </Collapse>
            </div>    
    ); 
  }
  
  export default Faq;